import { atom, selector } from "recoil";
import { getAppStore, getChannelTalk, getGooglePlay } from "lib/store/connect";
import { currentProject, projectUpdate } from "lib/store/project";

export const channelTalkUpdate = atom({
  key: "connect/list_update",
  default: new Date(),
});

export const asyncGetAPIConnects = selector({
  key: "connect/get",
  get: async ({ get }) => {
    get(projectUpdate);
    get(channelTalkUpdate);

    const pid = get(currentProject);
    if (isNaN(pid)) return;

    const apiList = {
      channelTalk: {
        uuid: "",
        created_at: "",
      },
      google_play: {},
      app_store: {},
    };

    try {
      apiList.channelTalk = await getChannelTalk(pid);
      apiList.google_play = await getGooglePlay(pid);
      apiList.app_store = await getAppStore(pid);
    } catch (e) {
      console.log(e.toString());
    }

    return apiList;
  },
});
